import { useEffect } from 'react'

const isIOS = typeof navigator !== 'undefined'
  && /iPad|iPhone|iPod/.test(navigator.userAgent)
  && !window.MSStream

const FOCUSABLE = ['INPUT', 'TEXTAREA', 'SELECT']

export function usePreventIOSAutoZoom() {
  useEffect(() => {
    if (!isIOS) return

    const viewportMeta = document.querySelector('meta[name="viewport"]')
    if (!viewportMeta) return

    const originalContent = viewportMeta.getAttribute('content')

    const lock = () => {
      const content = viewportMeta.getAttribute('content')
      if (!content.includes('maximum-scale=1')) {
        viewportMeta.setAttribute('content', content + ', maximum-scale=1')
      }
    }

    const unlock = () => {
      viewportMeta.setAttribute(
        'content',
        viewportMeta.getAttribute('content').replace(', maximum-scale=1', '')
      )
    }

    const onTouchStart = (e) => {
      if (FOCUSABLE.includes(e.target.tagName)) {
        lock()
      }
    }

    let unlockTimer = null
    const onFocusOut = (e) => {
      if (FOCUSABLE.includes(e.target.tagName)) {
        clearTimeout(unlockTimer)
        unlockTimer = setTimeout(unlock, 500)
      }
    }

    const onFocusIn = (e) => {
      if (FOCUSABLE.includes(e.target.tagName)) {
        clearTimeout(unlockTimer)
        lock()
      }
    }

    document.addEventListener('touchstart', onTouchStart, true)
    document.addEventListener('focusin', onFocusIn, true)
    document.addEventListener('focusout', onFocusOut, true)

    return () => {
      clearTimeout(unlockTimer)
      document.removeEventListener('touchstart', onTouchStart, true)
      document.removeEventListener('focusin', onFocusIn, true)
      document.removeEventListener('focusout', onFocusOut, true)
      viewportMeta.setAttribute('content', originalContent)
    }
  }, [])
}
